// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app-view-box {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  overflow: auto;\n}\n#sso-web-view-box, div[data-name=sso-web] {\n  height: 100%;\n}\n.entry-layout-sider.ant-layout-sider {\n  background: #ffffff;\n}\n.custom-form .ant-checkbox-group {\n  display: block;\n}\n.custom-form .ant-modal-body {\n  max-height: 70vh;\n  overflow: auto;\n}\n.custom-form .ant-modal-footer {\n  background-color: #FAFAFA;\n}\n", ""]);
// Exports
module.exports = exports;
